/**
 * This helper class implements functionality
 * to safely create instances of an inheriting
 * class on an HTMLElement. Every new constructor
 * will return the same instance with options provided
 * during the first creation of the instance
 * until PrkOneInstance.destroy method is called.
 */
export class PrkOneInstance {

    static DATASET_ATTRIBUTE = 'prk-instance-id';
    static DATASET_ID        = 'prkInstanceId';
    static instanceCounter   = 0;
    static instanceList      = {};

    /**
     * @protected
     * @var {HTMLElement}
     */
    element;

    /**
     * @protected
     * @var {boolean}
     */
    isInitialized = true;

    /**
     * !IMPORTANT use 'if (super(element)) return this' in the inheriting class constructor
     * @param {HTMLElement} element
     * @returs {boolean} true if instance from PrkOneInstance.instanceList, false otherwise
     */
    constructor (element) {
        this.element = element;

        if (!this.id) {
            this.id = this.generateId();
            PrkOneInstance.instanceList[this.id] = this;
            this.isInitialized = false;
        }
    }

    /**
     * @public
     * @returns {string}
     */
    get id () {
        return this.element.dataset[PrkOneInstance.DATASET_ID] || '';
    }

    /**
     * @public
     * @param {string} value
     */
    set id (value) {
        this.element.dataset[PrkOneInstance.DATASET_ID] = `${value}`;
    }

    /**
     * @public
     * @returns {PrkOneInstance|null}
     */
    get instance () {
        return PrkOneInstance.instanceList[this.id] || null;
    }

    /**
     * @private
     * @returns {string}
     */
    generateId () {
        return `${PrkOneInstance.instanceCounter++}`;
    }

    /**
     * Removes instance from PrkOneInstance.instanceList
     * @protected
     */
    destroy () {
        PrkOneInstance.instanceList[this.id] = undefined;
        this.id = '';
    }
}

window.PrkOneInstance = PrkOneInstance;

export default PrkOneInstance;
